import { createReducer } from '@src/api/createRequestStore';
import { combineReducers } from 'redux';
import baseReducer, { ChartsTabKey, AdContentTabKey, BenchmarkTabKey } from './reducer';

import { IMP_OPP_CHARTS, IMP_OPP_AD_CONTENT, IMP_BENCHMARK } from './types';

export { SCOPE } from './types';
export { default as selectors } from './selectors';
export { default as sagas } from './sagas';

export const reducer = combineReducers({
  base: baseReducer,
  [BenchmarkTabKey]: createReducer(IMP_BENCHMARK),
  [ChartsTabKey]: createReducer(IMP_OPP_CHARTS),
  [AdContentTabKey]: createReducer(IMP_OPP_AD_CONTENT),
});
